import { render, staticRenderFns } from "./colorPicker.vue?vue&type=template&id=65f1d39a&"
import script from "./colorPicker.vue?vue&type=script&lang=js&"
export * from "./colorPicker.vue?vue&type=script&lang=js&"
import style0 from "./colorPicker.vue?vue&type=style&index=0&id=65f1d39a&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports